import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Building2, ChefHat, Heart, Music } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Services() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-20%', '20%']);
  const services = [{
    title: 'Exclusive Venue',
    description: 'A stunning restaurant setting with elegant indoor and outdoor spaces tailored for your celebration.',
    icon: Building2,
    direction: 'right' as const
  }, {
    title: 'Culinary Excellence',
    description: 'Customized wedding menus crafted by our award-winning chefs to delight your guests.',
    icon: ChefHat,
    direction: 'left' as const
  }, {
    title: 'Full Planning Support',
    description: 'A dedicated wedding coordinator to handle every detail, ensuring a stress-free experience.',
    icon: Heart,
    direction: 'right' as const
  }, {
    title: 'Entertainment & Ambiance',
    description: 'Custom lighting, music, and décor arrangements to set the perfect mood for your evening.',
    icon: Music,
    direction: 'left' as const
  }];
  return <section id="services" ref={ref} className="relative py-32 md:py-44 text-white overflow-hidden" data-id="element-179">
      {/* Parallax Background Image */}
      <motion.div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://code-11.hr/wp-content/uploads/2025/05/2G6A8559-scaled.jpg")',
      y,
      scale: 1.2
    }} data-id="element-180">
        <div className="absolute inset-0 bg-charcoal/80" data-id="element-181" />
      </motion.div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-182">
        <FadeIn data-id="element-183">
          <div className="mb-24 md:mb-32 text-center flex flex-col items-center" data-id="element-184">
            <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-185">
              Our Expertise
            </span>
            <motion.div className="h-[1px] bg-copper mb-8" initial={{
            width: 0
          }} whileInView={{
            width: 32
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: 0.5,
            ease: [0.21, 0.47, 0.32, 0.98]
          }} data-id="element-186" />
            <h2 className="text-3xl md:text-4xl font-serif font-normal" data-id="element-187">
              What We <span className="italic text-white/60" data-id="element-188">Offer</span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-189">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <FadeIn key={index} delay={index * 0.15} direction={service.direction} data-id="element-190">
                <div className="group relative bg-white/5 backdrop-blur-sm border border-white/10 p-10 h-full overflow-hidden transition-colors hover:bg-white/10" data-id="element-191">
                  <motion.div initial={{
                scale: 0.5,
                opacity: 0
              }} whileInView={{
                scale: 1,
                opacity: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.8,
                delay: 0.3 + index * 0.1
              }} data-id="element-192">
                    <Icon className="w-8 h-8 text-copper mb-8" strokeWidth={1} data-id="element-193" />
                  </motion.div>

                  <h3 className="text-xl font-serif mb-4 font-normal tracking-wide" data-id="element-194">
                    {service.title}
                  </h3>
                  <p className="font-sans text-white/60 font-light leading-relaxed text-sm" data-id="element-195">
                    {service.description}
                  </p>

                  {/* Expanding Underline */}
                  <div className="absolute bottom-0 left-0 h-[2px] bg-copper w-0 group-hover:w-full transition-all duration-700 ease-out" data-id="element-196" />
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}